import React, { useState, useEffect } from "react";

import { PopoversBootrap } from "../../GenericComponent/PopoversBootrap";


export const ContentTable = ({ dataDanhSach, onSearch }) => {
  const setModalEdit = (item) => {
    item.onSearch = onSearch;
    setDataFocus(item);
    handleShowEdit();
  };

  const ShowConfirmDelete = (item) => {
    item.onSearch = onSearch;
    setDataFocus(item);
    handleShowEdit();
  };

  const [dataFocus, setDataFocus] = useState({});
  const [showEdit, setShowEdit] = useState(false);
  const handleCloseEdit = () => setShowEdit(false);
  const handleShowEdit = () => setShowEdit(true);
  const [isModalXoa, setModalXoa] = useState(false);
  const toggleModalXoa = () => {
    setModalXoa(!isModalXoa);
  };
  const deleteBank = (item) => {
    setDataFocus(item);
    toggleModalXoa();
  }
  //Phần  lien kết ngân hàng
  const showDangKyPushBDSD = (item) => {
    setDataFocus(item);
    toggleModalLienKet();
  };
  const [isModalLienKet, setModalLienKet] = useState(false);
  const toggleModalLienKet = () => {
    setModalLienKet(!isModalLienKet);
  };
  // end lien kết ngân hàng

  //Phần huy lien kết ngân hàng
  const showHuyDangKyPushBDSD = (item) => {
    setDataFocus(item);
    toggleModalHuyLienKet();
  };
  const [isModalHuyLienKet, setModalHuyLienKet] = useState(false);
  const toggleModalHuyLienKet = () => {
    setModalHuyLienKet(!isModalHuyLienKet);
  };
  // end lien kết ngân hàng


  return dataDanhSach.List.map((item, index) => (
    <div className="custom-table-row" key={item.Id}>
      <div className="custom-table-cell username-cell flex-basis-5 flex-basis-6-sm disk-mobile">
        <span className="mobile-column-name">STT</span>
        <div className="center-wrapper">
          <p className="text-center color7">{index + 1}</p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-10 flex-basis-19-sm  action-cell">
        <span className="mobile-column-name">Mã tham chiếu</span>
        <div className="center-wrapper">
          <p className="text-center color7">{item.referenceNumber}</p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-10 flex-basis-20-sm  action-cell">
        <span className="mobile-column-name">Số tài khoản</span>
        <div className="center-wrapper">
          <p className="text-center color7">{item.accountNumber}</p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-10 flex-basis-20-sm  action-cell">
        <span className="mobile-column-name">Ngày giao dịch</span>
        <div className="center-wrapper">
          <p className="text-center">{item.NgayGiaoDich}</p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-10 flex-basis-20-sm  action-cell">
        <span className="mobile-column-name">Số tiền</span>
        <div className="center-wrapper">
          <p className="text-center color7">{item.amount}</p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-10 flex-basis-20-sm  action-cell">
        <span className="mobile-column-name">Nội dung</span>
        <div className="center-wrapper">
          <p className="text-center color7">{item.paymentDetail}</p>
        </div>
      </div>
    </div>
  ));
};
